import Profile from "./Profile";
import ChangePassword from "./ChangePassword";

const AccountConfigs = {
    Profile,
    ChangePassword
};

export default AccountConfigs;
